// === FIXED VERSION - Loads jQuery safely first ===
if (typeof jQuery === 'undefined') {
  var jq = document.createElement('script');
  jq.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
  jq.onload = function() { initAllSwipers(); };
  document.head.appendChild(jq);
} else {
  initAllSwipers();
}

function initAllSwipers() {
  $(document).ready(function() {
    setupMainSwiper();
    setupLogoNavigation();
    inlineSwiper();
    setupSwiperEvents();
  });
}

// ================== YOUR ORIGINAL CODE BELOW ==================

function setupMainSwiper() {
  $('.swiper-container.swiper-logo').each(function() {
    var $container = $(this);
    var sectionId = $container.closest('[data-section-id]').attr('data-section-id');
    var blocksPerView = parseInt($container.closest('[data-blocks-per-view]').attr('data-blocks-per-view')) || 5;
    var autoplaySpeed = parseInt($container.closest('[data-autoplay]').attr('data-autoplay')) || 0;
    var mobileItems = parseInt($container.closest('[data-mobile-items]').attr('data-mobile-items')) || 2;
    var totalBlocks = parseInt($container.closest('[data-blocks-count]').attr('data-blocks-count')) || 0;
    
    if (totalBlocks === 0) return;
    
    var autoplayConfig = false;
    if (autoplaySpeed > 0) {
      autoplayConfig = {
        delay: autoplaySpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    
    var swiper = new Swiper($container[0], {
      slidesPerView: mobileItems,
      spaceBetween: 20,
      autoplay: autoplayConfig,
      loop: totalBlocks > blocksPerView,
      pagination: {
        el: '#swiper-pagination-' + sectionId,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      navigation: {
        nextEl: '.swiper-button-next-' + sectionId,
        prevEl: '.swiper-button-prev-' + sectionId,
      },
      breakpoints: {
        768: {
          slidesPerView: Math.min(blocksPerView, totalBlocks),
          spaceBetween: 30
        }
      },
      on: {
        init: function() {
          if (totalBlocks <= blocksPerView) {
            $('#swiper-pagination-' + sectionId).hide();
          }
        }
      }
    });
    
    $container.data('swiper', swiper);
  });
}

function setupLogoNavigation() {
  function positionLogos() {
    $('.logo-bar').each(function() {
      var $logoBar = $(this);
      var $container = $logoBar.find('.hero-container');
      
      if ($container.hasClass('-inline-slider')) {
        var slideshow = $('#MainContent .slideshow-section');
        
        if (slideshow.length && slideshow.hasClass('-overlap-header')) {
          $logoBar.addClass('-positioned-over-slideshow');
          var slideshowHeight = slideshow.outerHeight();
          var logoBarHeight = $logoBar.outerHeight();
          var positionTop = slideshowHeight - (logoBarHeight / 2);
          
          $logoBar.css({
            'position': 'absolute',
            'top': positionTop + 'px',
            'left': '0',
            'right': '0',
            'z-index': '10'
          });
        } else {
          $logoBar.removeClass('-positioned-over-slideshow');
          $logoBar.css({
            'position': '',
            'top': '',
            'left': '',
            'right': '',
            'z-index': ''
          });
        }
      }
    });
  }
  
  positionLogos();
  $(window).on('resize', positionLogos);
  setTimeout(positionLogos, 1000);
}

function inlineSwiper() {
  $('[id^="inline-swiper-"]').each(function() {
    var $swiper = $(this);
    var sectionId = $swiper.attr('id').replace('inline-swiper-', '');
    var $section = $swiper.closest('[data-section-id="' + sectionId + '"]');
    
    if ($section.length === 0) return;
    
    var blocksPerView = parseInt($section.attr('data-blocks-per-view')) || 5;
    var autoplaySpeed = parseInt($section.attr('data-autoplay')) || 0;
    var mobileItems = parseInt($section.attr('data-mobile-items')) || 2;
    var totalBlocks = parseInt($section.attr('data-blocks-count')) || 0;
    
    if (totalBlocks === 0) return;
    
    var autoplayConfig = false;
    if (autoplaySpeed > 0) {
      autoplayConfig = {
        delay: autoplaySpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }
    
    if ($swiper.data('swiper')) {
      $swiper.data('swiper').destroy(true, true);
    }
    
    var swiper = new Swiper($swiper[0], {
      slidesPerView: mobileItems,
      spaceBetween: 20,
      autoplay: autoplayConfig,
      loop: totalBlocks > blocksPerView,
      grabCursor: true,
      pagination: {
        el: '#swiper-pagination-' + sectionId,
        clickable: true,
        dynamicBullets: true
      },
      breakpoints: {
        768: {
          slidesPerView: Math.min(blocksPerView, totalBlocks),
          spaceBetween: 30,
          pagination: totalBlocks > blocksPerView ? {
            el: '#swiper-pagination-' + sectionId,
            clickable: true,
            dynamicBullets: true
          } : false
        }
      }
    });
    
    $swiper.data('swiper', swiper);
    
    if ($(window).width() >= 768 && totalBlocks <= blocksPerView) {
      $('#swiper-pagination-' + sectionId).hide();
    }
  });
}

function setupSwiperEvents() {
  $(window).on('resize', function() {
    clearTimeout(window.swiperResizeTimeout);
    window.swiperResizeTimeout = setTimeout(function() {
      $('.swiper-container').each(function() {
        var swiper = $(this).data('swiper');
        if (swiper) {
          swiper.update();
          
          var $section = $(this).closest('[data-section-id]');
          if ($section.length) {
            var sectionId = $section.attr('data-section-id');
            var blocksPerView = parseInt($section.attr('data-blocks-per-view')) || 5;
            var totalBlocks = parseInt($section.attr('data-blocks-count')) || 0;
            
            if ($(window).width() >= 768 && totalBlocks <= blocksPerView) {
              $('#swiper-pagination-' + sectionId).hide();
            } else {
              $('#swiper-pagination-' + sectionId).show();
            }
          }
        }
      });
    }, 250);
  });
  
  $(document).on('shopify:section:load', function(e) {
    var $section = $(e.target);
    if ($section.find('.swiper-container').length) {
      setTimeout(function() {
        setupMainSwiper();
        inlineSwiper();
      }, 100);
    }
  });
  
  $(document).on('shopify:section:unload', function(e) {
    var $section = $(e.target);
    $section.find('.swiper-container').each(function() {
      var swiper = $(this).data('swiper');
      if (swiper) {
        swiper.destroy(true, true);
      }
    });
  });
}

function reinitializeSwipers() {
  $('.swiper-container').each(function() {
    var swiper = $(this).data('swiper');
    if (swiper) {
      swiper.destroy(true, true);
    }
  });
  
  setTimeout(function() {
    setupMainSwiper();
    inlineSwiper();
  }, 100);
}

window.reinitializeSwipers = reinitializeSwipers;